export const catchError = (error) => ({ type: "CATCH_ERROR", error });
export const hideError = () => ({ type: "HIDE_ERROR" });
